import videojs from 'video.js';
import Player from 'video.js/dist/types/player';

export class Video {
  private videoElements: NodeListOf<HTMLVideoElement> = document.querySelectorAll('.js-videojs');

  constructor() {
    this.videoElements?.forEach(element => {
      this.handleVideos(element);
    });
  }

  private handleVideos(video: HTMLVideoElement) {
    const player: Player = videojs(video);

    // Event-Listener für den Vollbildmodus mit Video.js-spezifischem Event
    player?.on('fullscreenchange', () => {
      const sdSource = video.querySelector('source[data-source="sourcesd"]') as HTMLSourceElement;
      const sourceHd = video.querySelector('source[data-source="sourcehd"]') as HTMLSourceElement;
      const currentTime = player.currentTime();

      if (sdSource && sourceHd) {
        if (player.isFullscreen()) {
          player.src({ type: 'video/mp4', src: sourceHd.src });
          player.currentTime(currentTime);
          player.play();

        } else {
          player.src({ type: 'video/mp4', src: sdSource.src });
          player.currentTime(currentTime);
          player.play();
        }
      }
    });
  }
}

new Video();
